import React from "react";

const ShippingPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-6 mt-16">
      <div className="bg-white shadow-lg rounded-lg w-5/6 max-w-6xl p-10">
        <h1 className="text-4xl font-bold text-center text-gray-800 mb-6">Shipping & Delivery Policy</h1>

        <section className="mb-8">
          <p className="text-gray-600">
            - Results are available <strong>instantly</strong> after payment through a <strong>downloadable PDF</strong>.  
            - If a valid email is provided, users <strong>may</strong> receive the result via email.  
            - If users enter an incorrect email, they can request results within <strong>7 days</strong>.  
          </p>
        </section>

        <div className="text-center mt-6">
          <a href="/" className="text-blue-500 hover:underline text-lg">← Go Back</a>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;
